import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { environment } from "../../../environments/environment.dev";
import { HttpClient } from "@angular/common/http";
import { IRequestAccess, ISubscriptionDetails, IUser } from "../../@core/models/model";
import { CheckoutConfig } from "src/app/pricing/checkout-dialog/checkout-dialog.component";
import { EntityUnit, TermUnit } from "src/app/pricing/models";

export interface CreditsTopupItem {
    requestId: string;
    userId: string;
    name: string;
    email: string;
    askCredits: number;
    agentCredits: number;
    totalAmount: number;
}

export enum CHECKOUT_SESSION_TYPE {
    ADD_CREDITS = 'ADD_CREDITS',
    ACCEPT_REQUEST = 'ACCEPT_REQUEST',
}


export interface CreditsTopupPayload {
    users: {
        user: IUser['_id'],
        askCredits: number,
        agentCredits: number,
        requestId?: IRequestAccess['_id']
    }[];
    successUrl: string;
    cancelUrl: string;
    source?: CHECKOUT_SESSION_TYPE;
}

export interface CreditsTopupCheckoutResponse {
    checkoutUrl: string;
}

@Injectable({ providedIn: 'root' })
export class PaymentService extends BaseService {
    apiUrl = environment.apiUrl + '/payment/'

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    getSubscriptionDetails() {
        return this.get<ISubscriptionDetails>(this.apiUrl + 'subscription-details')
    }

    createCheckoutSession(checkoutData: CheckoutConfig) {
        return this.post(this.apiUrl + 'create-checkout-session', checkoutData)
    }

    createCheckoutSessionCreditsTopup(payload: CreditsTopupPayload) {
        return this.post<CreditsTopupCheckoutResponse>(this.apiUrl + 'create-checkout-session-credits-topup', payload)
    }

    createCustomerPortalSession() {
        return this.post<string>(this.apiUrl + 'customer-portal', {})
    }

    cancelSubscription() {
        return this.post<{ cancelAtDate: Date }>(this.apiUrl + 'cancel-subscription', {})
    }

    revokeSubscriptionCancellation() {
        return this.post(this.apiUrl + 'revoke-subscription-cancellation', {})
    }

    scheduleDowngrade(targetPlanId: string) {
        return this.post(this.apiUrl + 'schedule-downgrade', { targetPlanId })
    }

    cancelScheduledDowngrade() {
        return this.delete(this.apiUrl + 'scheduled-downgrade')
    }

    getInvoices() {
        return this.get<any>(this.apiUrl + 'invoices')
    }

    getProratedCharge(requestId: string) {
        return this.get<{ proratedCharge: number; daysRemaining: number; cycleDays: number }>(
            this.apiUrl + 'prorated-charge',
            { requestId }
        );
    }

    getOrgProratedCharge(newPlanId: string, billingEntity?: EntityUnit, pricingTerm?: TermUnit) {
        return this.get<{
            proratedCharge: number;
            daysRemaining: number;
            cycleDays: number;
            cycleHours: number;
            hoursRemaining: number;
            userCount: number;
            usersAlreadyUpgraded: number;
            usersCharged: number;
        }>(this.apiUrl + 'org-prorated-charge', { newPlanId, billingEntity, pricingTerm });
    }

}
